import { IonSkeletonText } from '@ionic/react'
import React, { forwardRef } from 'react'
import { useCounterAnimation } from '../hooks/useCounterAnimation'

interface PointsCounterProps {
	points: number | null
	shouldAnimate?: boolean
}

const PointsCounter = forwardRef<HTMLDivElement, PointsCounterProps>(
	({ points, shouldAnimate = false }, ref) => {
		const animatedPoints = useCounterAnimation(points ?? 0, 1000, shouldAnimate)
		const isLoading = points === null

		return (
			<div ref={ref} className='flex items-center justify-center mb-2 gap-2'>
				<img src='/assets/star-white.svg' alt='star' className='h-8 w-8 text-4xl font-bold' />
				<span className='relative flex items-center text-4xl font-bold text-white'>
					{isLoading ? (
						<>
							<span
								style={{ visibility: 'hidden', pointerEvents: 'none', userSelect: 'none' }}
								aria-hidden='true'
							>
								100
							</span>
							<IonSkeletonText className='absolute left-0 right-0 h-full w-full' />
						</>
					) : (
						<>
							<span
								style={{ visibility: 'hidden', pointerEvents: 'none', userSelect: 'none' }}
								aria-hidden='true'
							>
								{points}
							</span>
							<span className='absolute left-0 right-0 w-full text-left'>{animatedPoints}</span>
						</>
					)}
				</span>
			</div>
		)
	}
)

PointsCounter.displayName = 'PointsCounter'

export default PointsCounter
